import * as React from 'react';

import { OfferImage } from '@affiliates/components';
import { OFFER_SOURCE } from '@affiliates/types/globalTypes';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shadcn/components/ui/tooltip';

interface IProps {
    name: string;
    imageUrl: string;
    source: OFFER_SOURCE;
    iconName: string | null;
}

export const RefreshOfferNameCell: React.FC<Readonly<IProps>> = React.memo((props) => (
  <div className="flex flex-row flex-grow gap-2 items-center cursor-pointer">
    <div className="flex">
      <OfferImage
        className="w-8 h-[31PX] rounded-md cursor-pointer"
        imageUrl={props.imageUrl}
        source={props.source}
        iconName={props.iconName}
      />
    </div>
    <div>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="truncate max-w-[180px] inline-block align-middle text-sm font-normal text-primary hover:underline cursor-default">
            {props.name.length > 30 ? `${props.name.substring(0, 30)}...` : props.name}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <span className="break-all">{props.name}</span>
        </TooltipContent>
      </Tooltip>
    </div>
  </div>
));

RefreshOfferNameCell.displayName = 'OfferNameCell';
